/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PlayerCareer = {
    properties: {
        senior: {
            type: 'array',
            contains: {
                type: 'PlayerCareerEntry',
            },
            isRequired: true,
        },
        youth: {
            type: 'array',
            contains: {
                type: 'PlayerCareerEntry',
            },
            isRequired: true,
        },
    },
} as const;
